<template>
	<div class="official-recommend-page">
		<div class="content-container">
			<div class="breadcrumb">
				<router-link to="/" class="breadcrumb-item">首页</router-link>
				<span class="breadcrumb-separator">></span>
				<span class="breadcrumb-item current">官方推荐</span>
			</div>
			<div class="titleBox">
				<div class="title">热门{{$route.query.type == 1 ? '材质' : '模型'}}推荐</div>
				<div class="subTitle">资产种类繁多，满足各种各样的需求。</div>
			</div>
			<div class="orderListBox">
				<div class="orderList" v-if="huaList.length">
					<div class="orderItem" v-for="(item,index) in huaList" :key="index"
						@click="curGoods = item;workDetailsShow = true">
						<img class="orderImg" :src="item.img" />
						<div class="orderName">{{item.title}}</div>
					</div>
				</div>
			</div>
			<PagePagination v-if="total > 0" style="padding: .6rem 0 .6rem;" :currentPage="currentPage" :pageSize="12"
				:total="total" @current-change="onPageChange" />
		</div>
		<WorkDetailsDialog :show="workDetailsShow" :isBuy="curGoods.is_buy" :goodsId="curGoods.id"
			@close="workDetailsShow = false" />
	</div>
</template>

<script>
	import WorkDetailsDialog from '../components/WorkDetailsDialog.vue'
	export default {
		name: 'OfficialRecommend',
		components: {
			WorkDetailsDialog
		},
		data() {
			return {
				workDetailsShow: false,
				curGoods: {},
				huaList: [],
				currentPage: 1, // 当前页码
				total: 0, // 总条数
			}
		},
		mounted() {
			this.headerGoodsList()
		},
		methods: {
			// 页码变化处理
			onPageChange(newPage) {
				this.currentPage = newPage
				this.headerGoodsList()
			},
			headerGoodsList() {
				this.$api.post('/Goods/top_goods_list', {
					pagesize: 12,
					p: this.currentPage,
					type: this.$route.query.type,
					user_id: localStorage.getItem('userId') ? localStorage.getItem('userId') : '',
				}).then(res => {
					if (res.code == 1) {
						this.total = res.data.count
						this.huaList = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.official-recommend-page {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
	}

	@media (max-width: 480px) {

		/* 面包屑导航样式 */
		.breadcrumb {
			margin-top: .32rem;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .28rem;
			color: rgba(255, 255, 255, .6);
		}

		.breadcrumb-item {
			color: rgba(255, 255, 255, .6);
			text-decoration: none;
			transition: color 0.3s ease;
		}

		.breadcrumb-item:hover {
			color: rgba(255, 255, 255, 1);
		}

		.breadcrumb-item.current {
			color: rgba(255, 255, 255, .6);
			font-weight: 500;
		}

		.breadcrumb-separator {
			margin: 0 0.02rem;
			color: rgba(255, 255, 255, .6);
		}

		.titleBox {
			margin: .32rem auto 0;
			width: 12rem;
			display: flex;
			flex-direction: column;

			.title {
				font-weight: 500;
				font-size: .56rem;
				color: #FFFFFF;
				line-height: .8rem;
			}

			.subTitle {
				margin-top: .24rem;
				font-weight: 400;
				font-size: .36rem;
				color: #FFFFFF;
				line-height: .48rem;
			}
		}

		.orderListBox {
			margin: 0 auto;
			display: flex;
			align-items: center;
			flex-direction: column;
			width: 12rem;

			.more {
				margin-top: .8rem;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 2.4rem;
				height: 1rem;
				background: #1673E6;
				border-radius: .5rem;
				backdrop-filter: blur(2px);
				font-weight: 400;
				font-size: .36rem;
				color: #FFFFFF;
				line-height: .52rem;
				cursor: pointer;
			}

			.orderList {
				width: 100%;
				display: flex;
				flex-wrap: wrap;

				.orderItem:nth-child(2n) {
					margin-right: 0;
				}

				.orderItem {
					margin-top: .8rem;
					margin-right: .48rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;

					.orderImg {
						width: 5.64rem;
						height: 5.64rem;
						border-radius: .16rem;
						object-fit: cover;
					}

					.orderName {
						margin-top: .56rem;
						width: 5.64rem;
						font-weight: 500;
						font-size: .36rem;
						color: #FFFFFF;
						line-height: .5rem;
					}

					.collection {
						margin-top: .48rem;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 3.76rem;
						height: .72rem;
						background: #1673E6;
						border-radius: .36rem;
						font-weight: 400;
						font-size: .28rem;
						color: #FFFFFF;
						line-height: .4rem;

						.collectionIcon {
							margin-right: .08rem;
							width: .28rem;
							height: .28rem;
						}
					}
				}
			}
		}
	}

	@media (min-width: 481px) {


		/* 面包屑导航样式 */
		.breadcrumb {
			margin-top: .32rem;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: rgba(255, 255, 255, .6);
		}

		.breadcrumb-item {
			color: rgba(255, 255, 255, .6);
			text-decoration: none;
			transition: color 0.3s ease;
		}

		.breadcrumb-item:hover {
			color: rgba(255, 255, 255, 1);
		}

		.breadcrumb-item.current {
			color: rgba(255, 255, 255, .6);
			font-weight: 500;
		}

		.breadcrumb-separator {
			margin: 0 0.02rem;
			color: rgba(255, 255, 255, .6);
		}

		.titleBox {
			margin: .32rem auto 0;
			width: 12rem;
			display: flex;
			flex-direction: column;

			.title {
				font-weight: 500;
				font-size: .28rem;
				color: #FFFFFF;
				line-height: .4rem;
			}

			.subTitle {
				margin-top: .12rem;
				font-weight: 400;
				font-size: .18rem;
				color: #FFFFFF;
				line-height: .24rem;
			}
		}

		.orderListBox {
			margin: 0 auto;
			display: flex;
			align-items: center;
			flex-direction: column;
			width: 12rem;

			.orderList {
				width: 100%;
				display: flex;
				flex-wrap: wrap;

				.orderItem:nth-child(4n) {
					margin-right: 0;
				}

				.orderItem {
					margin-top: .4rem;
					margin-right: .24rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;

					.orderImg {
						width: 2.82rem;
						height: 2.82rem;
						border-radius: .08rem;
						object-fit: cover;
					}

					.orderName {
						margin-top: .28rem;
						width: 2.82rem;
						font-weight: 500;
						font-size: .18rem;
						color: #FFFFFF;
						line-height: .25rem;
					}

					.collection {
						margin-top: .24rem;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 1.88rem;
						height: .36rem;
						background: #1673E6;
						border-radius: .18rem;
						font-weight: 400;
						font-size: .14rem;
						color: #FFFFFF;
						line-height: .2rem;

						.collectionIcon {
							margin-right: .04rem;
							width: .14rem;
							height: .14rem;
						}
					}
				}
			}
		}
	}
</style>